import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ABTestComponent } from './abtest.component';

@NgModule({
  imports: [CommonModule],
  exports: [ABTestComponent],
  declarations: [ABTestComponent],
})
export class ABTestModule {}
